export const enviroment = {
    // apiUrl: 'https://money-manager-master-be.herokuapp.com'
    apiUrl: 'http://localhost:3001'
}